<template lang="html">
  <v-container fluid grid-list-lg>
    <v-row row wrap>
      <v-col xs12 md6 class="pa-5">
            <v-text-field v-model="email" filled clear-icon="clear" :label="$t('User.Email')" type="email" disabled>
            </v-text-field>
            <v-text-field v-model="phone_number" filled clear-icon="clear" :label="$t('User.PhoneNumber')" type="string" :disabled="!this.isAccountInfoEditMode" @input="update_flags.phone_number = true">
            </v-text-field>
            <v-text-field v-model="first_name" filled clear-icon="clear" :label="$t('User.FirstName')" type="string" :disabled="!this.isAccountInfoEditMode" @input="update_flags.first_name = true">
            </v-text-field>
            <v-text-field v-model="last_name" filled clear-icon="clear" :label="$t('User.LastName')" type="email" :disabled="!this.isAccountInfoEditMode" @input="update_flags.last_name = true">
            </v-text-field>

          <v-row class="pa-5" v-if="!this.isAccountInfoEditMode">
            <v-btn @click="editPersonalInfomation()" color="lighten-1"><v-icon dark>edit</v-icon>{{$t('Account.AccountInfo.Edit')}}</v-btn>
          </v-row>
          <v-row class="pa-5" v-else>
            <v-btn @click="savePersonalInfomation()" color="orange lighten-1 mr-5 mb-5"><v-icon dark>save</v-icon>{{$t('Account.AccountInfo.Save')}}</v-btn>
            <v-btn @click="setAccountInfoEditMode(false);" color="lighten-1"><v-icon dark>cancel</v-icon>Cancel</v-btn>
          </v-row>
          <v-row class="pa-5">
            <v-btn @click="logout()" color="red lighten-1"><v-icon dark>logout</v-icon>Logout</v-btn>
          </v-row>

      </v-col>
      <v-col xs12 md6 class="pa-5">
        <v-hover v-slot:default="{ hover }">
          <v-avatar color="grey" tile size="164" >
            <span v-if="getUser.image==='noimage'" class="white--text headline">
              {{getUser.first_name[0].toUpperCase() + getUser.last_name[0].toUpperCase()}}
            </span>
            <v-img
              v-if="getUser.image!=='noimage'"
              height="100%"
              :src="getUser.image"
            >
            </v-img>
            <v-expand-transition>
              <div
                v-if="hover"
                class="d-flex transition-fast-in-fast-out grey darken-2 image-upload-hover display-1 white--text"
                style="height: 75%;"
                >
                <!-- <v-btn @click="selectImage()" icon class="upload-btn">
                  <v-file-input id="user-image-upload" v-show="false" type="file" @change="uploadeImage()"/>
                  <v-icon x-large>add_a_photo</v-icon>
                </v-btn> -->
                <v-btn @click="test()" icon class="upload-btn">
                  <input ref="user_img" v-show="false" type="file" @change="uploadeImage()"/>
                  <v-icon x-large>add_a_photo</v-icon>
                </v-btn>
              </div>
            </v-expand-transition>
          </v-avatar>
        </v-hover>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  mapActions,
  mapGetters
} from 'vuex';
export default {
  name: 'AccountInfo',
  data: function() {
    return {
      update_flags: {
        phone_number: false,
        first_name: false,
        last_name: false,
      },
      error_msg: '',
      rules: [
        value => !value || value.size < 2000000 || 'Avatar size should be less than 2 MB!',
      ],
    }
  },
  computed: {
    ...mapGetters('View', [
      'isAccountInfoEditMode'
    ]),
    ...mapGetters('Auth', [
      'getUser'
    ]),
    email: {
      get() {
        return this.$store.state.Auth.current_user.email;
      },
      set(value) {
        this.$store.commit('Auth/update_email', value);
      }
    },
    phone_number: {
      get() {
        return this.$store.state.Auth.current_user.phone_number;
      },
      set(value) {
        this.$store.commit('Auth/update_phone_number', value);
      }
    },
    first_name: {
      get() {
        return this.$store.state.Auth.current_user.first_name;
      },
      set(value) {
        this.$store.commit('Auth/update_first_name', value);
      }
    },
    last_name: {
      get() {
        return this.$store.state.Auth.current_user.last_name;
      },
      set(value) {
        this.$store.commit('Auth/update_last_name', value);
      }
    },
  },
  methods: {
    ...mapActions('View', [
      'setAccountInfoEditMode'
    ]),
    ...mapActions('User', [
      'updateUser',
      'userImageUpload'
    ]),
    editPersonalInfomation() {
      this.setAccountInfoEditMode(true);
      this.update_flags.phone_number = false;
      this.update_flags.first_name = false;
      this.update_flags.last_name = false;
    },
    savePersonalInfomation() {
      let payload = {
        id: this.$store.state.Auth.current_user.id,
        update: {}
      }
      if (this.update_flags.phone_number == true) {
        payload.update.phone_number = this.$store.state.Auth.current_user.phone_number
      }
      if (this.update_flags.first_name == true) {
        payload.update.first_name = this.$store.state.Auth.current_user.first_name
      }
      if (this.update_flags.last_name == true) {
        payload.update.last_name = this.$store.state.Auth.current_user.last_name
      }
      if (
        this.update_flags.first_name == true ||
        this.update_flags.last_name == true ||
        this.update_flags.phone_number == true
      ) {
        this.updateUser(payload);
      }
    },
    logout() {
      this.$store.dispatch('Auth/logout', {});
    },
    selectImage(){
      document.getElementById('user-image-upload').click();
    },
    test() {
      this.$refs.user_img.click()
    },
    uploadeImage(){
      let form_data = new FormData();
      form_data.append('image', this.$refs.user_img.files[0]);
      this.userImageUpload({
        form_data: form_data,
        id: this.getUser.id
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.image-upload-hover {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: .75;
  position: absolute;
  width: 100%;
}
.upload-btn{
  height: 100px;
  width: 100px;
}
</style>
